module.exports = __webpack_public_path__ + "img/1.ed5bbfc7.jpg";